import * as Yup from 'yup';
import Translator from '../../core/i18n';
import { IValidation } from '../../models/components/validation-props';
import { DefaultValidation } from './main-validations';

const T = Translator.create();
export function getValidation(props?: IValidation) {

    const defaultValidation = new DefaultValidation(props);

    return Yup.object().shape({
        name: defaultValidation.GetName(),
        defaultValuesFormik: defaultValidation.SetDefaultValues(),
        examSessionBeginDate: props && props.isUpdate ? Yup.string() : defaultValidation.GetExamSessionBeginDate(),
        examSessionBeginDateTime: props && props.isUpdate ? Yup.string() : defaultValidation.GetExamSessionBeginDateTime(),
        examSessionEndDate: defaultValidation.GetExamSessionEndDate(),
        examSessionEndDateTime: defaultValidation.GetExamSessionEndDateTime(),
    });
}